import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

const GoogleTagManager = () => {
  const gtmId = process.env.REACT_APP_GTM_ID;  // Access the GTM ID from environment variable

  useEffect(() => {
    if (!gtmId) {
      console.error("GTM ID is missing from environment variables.");
    }
  }, [gtmId]);

  return (
    <>
      {/* GTM Script for <head> */}
      <Helmet>
        <script>
          {`
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${gtmId}');
          `}
        </script>
      </Helmet>

      {/* GTM noscript for <body> */}
      <noscript>
        <iframe
          src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
          title="Google Tag Manager"
        ></iframe>
      </noscript>
    </>
  );
};

export default GoogleTagManager;
